// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3WnuR","footer":"Form_footer__1rEnU"};